import { gqlClient } from '@/api/graphql-client';
import estimateKeys from '@/api/queries/estimates/keyFactory';
import { graphql } from '@/gql';
import {
  EstimateCategory,
  Scalars,
  UpdateEstimateDefaultItemInput,
  UpdateEstimateDefaultItemMutation as UpdateEstimateDefaultItemMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const UpdateEstimateDefaultItemMutation = graphql(`
  mutation UpdateEstimateDefaultItem(
    $id: ID!
    $input: UpdateEstimateDefaultItemInput!
  ) {
    updateEstimateDefaultItem(id: $id, input: $input) {
      id
      quantity
    }
  }
`);

type Variables = {
  id: Scalars['ID']['input'];
  input: UpdateEstimateDefaultItemInput;
  category: EstimateCategory;
};

const useUpdateEstimateDefaultItem = (
  options?: UseMutationOptions<
    UpdateEstimateDefaultItemMutationResult,
    Error,
    Variables
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, input }) => {
      return gqlClient.request(UpdateEstimateDefaultItemMutation, {
        id,
        input,
      });
    },
    onSettled: (_data, _error, variables) => {
      void queryClient.invalidateQueries({
        queryKey: estimateKeys.estimateDefaultItems(variables.category),
      });
    },
    ...options,
  });
};

export default useUpdateEstimateDefaultItem;
